(async () => {
    const { Core } = await importModule('Core');

    customElements.define('survey-popup', class extends Core {  
        
        elements = {
            content:  '[data-content]'
        }

        async render() {
            await customElements.whenDefined('modal-popup');
            this._initPopup();
            setTimeout(() => {
            var questionItemBoxes = document.querySelectorAll(".survey-modal .question_item--checkbox--wrapper");
            questionItemBoxes.forEach(function(questionItemBox){
              var checkBoxes = questionItemBox.querySelectorAll("input[type=checkbox]");
              checkBoxes.forEach(function(checkBox){
                checkBox.addEventListener("change", function(){
                  var closestQuestionItemBox = checkBox.closest(".question_item--checkbox--wrapper");
                  var foundChecked = false;
                  closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                   if(item.checked == true){
                     foundChecked = true;
                   }
                  });
                  if(foundChecked == true){
                     closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                      item.removeAttribute("required");
                     });
                  }else{
                    closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                      item.setAttribute("required","");
                     });
                  }
                });
              });
            });
          },2000);
        };

        _initPopup() {

          if(window.location.href.indexOf('form_type=contact#SurveyForm') >= 0 || window.location.href.indexOf('survey-popup') >= 0 || (window.location.href.includes('form_type=contact#contact_form') && (window.localStorage.getItem("specificProducts") != null && window.localStorage.getItem("specificProducts") != "") )) {
            this._showPopup();
          }else if(window.location.search.includes('?contact_posted=true', 'contact_posted%3Dtrue') && window.location.href.indexOf("SurveyForm") >= 0 || (window.location.search.includes('?contact_posted=true', 'contact_posted%3Dtrue') && (window.localStorage.getItem("specificProducts") != null && window.localStorage.getItem("specificProducts") != "") )){
            this._showPopup();  
            if(window.localStorage.getItem("specificProducts") != null && window.localStorage.getItem("specificProducts") != ""){
               var items = JSON.parse(window.localStorage.getItem("specificProducts"));
              this.publish('cart:add', {
                    items 
              });
              window.history.replaceState({}, document.title, window.location.pathname);
               var now = new Date();
			  localStorage.setItem("vendor_popup_expiry", now.getTime() + 86400000);
            }
           
          }
        };
    
        _showPopup() {
            setTimeout(this._trigerModal.bind(this), 1000);
        };
    
        _trigerModal() {
            this.publish('modal:open', {
                target: '#surveyPopupTemplateResult',
                backdrop: true,
                close: false,
                animation: 'fade',
                transition: 500,
                position: "center"
            });
        };

        get lastViewed() {
            return window.localStorage.getItem(LS_LAST_VIEWED);
        }

    });
})();